import { useCameraSession } from '@hooks/utils/useCameraSession';
import { useLocalVideo } from '@providers/LocalVideoProvider';
import { currentCameraCheck } from '@stores/atoms/device';
import { useSetAtom } from 'jotai';
import type { FC } from 'react';
import { Container, IconWrapper } from './style';
import CameraIcon from '/icon/camera.svg';

const InterviewerCameraToggle: FC = () => {
  const setCurrentCameraCheck = useSetAtom(currentCameraCheck);
  const { isVideoEnabled, toggleVideo } = useLocalVideo();
  const { saveCameraState } = useCameraSession();

  const onClick = () => {
    setCurrentCameraCheck(!isVideoEnabled);
    saveCameraState(!isVideoEnabled ? 'on' : 'off');
    toggleVideo();
  };

  return (
    <Container onClick={onClick} isActive={isVideoEnabled}>
      <IconWrapper>
        <img src={CameraIcon} />
      </IconWrapper>
      <span>카메라</span>
    </Container>
  );
};

export default InterviewerCameraToggle;
